import { FiltroModel } from "./FiltroModel";
import { GroupModel } from "./GroupModel";

export class ReportModel {
    id: number;
    reportTitle: string;
    reportFilters : FiltroModel[];
    reportQuery : string;
    createdBy : string;
    createdOn : any; 
    hasFilters: boolean;    
    accessGroups: any;
    connectionId: number;
    isGrupoCadastro: boolean;
    
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/ReportModel.ts